import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const ChoosePlanContainer = styled.div`
  max-width: 100%;
  padding: 8px 0 6px !important;
  height: 100%;
  display: flex;
  overflow-x: auto;
  margin-left: -12px;
  & > .plan {
    margin-left: 16px;
    width: ${props =>
      props.childrenCounts
        ? "calc((100vw - 2 * 45px - " +
          (props.childrenCounts - 1) * 16 +
          "px ) /" +
          props.childrenCounts +
          ")"
        : ""};
    min-width: 300px;
  }
`;

export const FormTitle = styled.div`
  width: 100%;
  text-align: center;
  color: ${Variables.colors.complementary_900};
  font-size: ${Variables.font_sizes.x3_large};
  font-weight: ${Variables.font_weight.medium}
  margin: 0 0 4px 0;
  padding: 0;
`;
export const TitleTag = styled.div`
  width: 100%;
  text-align: center;
  color: ${Variables.colors.complementary_800};
  font-size: ${Variables.font_sizes.x2_medium};
  font-weight: ${Variables.font_weight.regular}
  margin: 0 0 0 0;
  padding: 0;
`;
export const FormRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px solid ${Variables.colors.complementary_400};
  padding-bottom: 20px;
  padding-top: 24px;
  text-align: center;
  &:last-child {
    border-bottom: 0px;
    padding-bottom: 0px;
  }
  .title {
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.complementary_900};
    text-align: center;
    width: 100%;
    margin-bottom: 24px;
  }
  .description {
    font-size: ${Variables.font_sizes.x_small};
    font-weight: ${Variables.font_weight.light};
    color: ${Variables.colors.complementary_700};
    width: 100%;
    max-width: 345px;
    line-height: 1.58;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: right;
    .description-icon {
      margin-left: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      &:before {
        margin: 0;
        font-size: 12px;
        color: ${Variables.colors.complementary_700};
      }
    }
  }
  .off-message {
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.green_800};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24px;
    .off-message-icon {
      margin-left: 8px;
      margin-bottom: 8px;
      &:before {
        margin: 0;
        font-size: 8px;
        color: ${Variables.colors.green_800};
      }
    }
  }
`;
export const SliderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: calc(100% - 44px);
  min-height: 70px;
  margin-bottom: 20px;
  .min,
  .max {
    color: ${Variables.colors.complementary_800};
    font-size: ${Variables.font_sizes.x_small};
  }
  .min {
    position: absolute;
    left: -30px;
    bottom: 3px;
  }
  .max {
    position: absolute;
    right: -30px;
    bottom: 3px;
  }
  .rc-slider-mark {
    display: none;
  }
`;
